import React from 'react';
import Layout from '@src/routers/Layout';
import ProviderWrapper from './Layout/Providers';
import Router from './Router';

const App = () => {
  return (
    <ProviderWrapper>
      <Layout>
        <Router />
      </Layout>
    </ProviderWrapper>
  );
};

export default App;
